import { InspectionRole, InspectorRoleSchema } from '@eigtech/claims-v2-types'
import { useGetDelegateUserActiveContacts } from '@/api'
import { useGetContactsAssignmentForClaim } from '@eigtech/ui-shared-contacts'
import { exhaustive } from 'exhaustive'
import { uniq } from 'lodash-es'
import { useMemo } from 'react'

export function useGetInspectorRolesForClaim(claimNumber: string) {
  const { contactIds } = useGetDelegateUserActiveContacts()

  const { assignments } = useGetContactsAssignmentForClaim({
    contactIds,
    claimNumber,
  })

  const inspectorRoles: InspectionRole[] = useMemo(
    () =>
      uniq(
        assignments.flatMap((assignment): InspectionRole[] =>
          exhaustive(assignment?.assignable?.assigneeRelationship ?? '_', {
            approver: () => [] satisfies InspectionRole[],
            carrier: () => [] satisfies InspectionRole[],
            coordinator: () => [] satisfies InspectionRole[],
            deskAdjuster: () => [] satisfies InspectionRole[],
            dispatcher: () => [] satisfies InspectionRole[],
            fieldAdjuster: () => [InspectorRoleSchema.enum.fieldAdjuster],
            fieldTechnician: () => [] satisfies InspectionRole[],
            inspectionTechnician: () => [InspectorRoleSchema.enum.inspectionTechnician],
            job: () => [] satisfies InspectionRole[],
            legalRep: () => [] satisfies InspectionRole[],
            policyHolder: () => [] satisfies InspectionRole[],
            primaryContact: () => [] satisfies InspectionRole[],
            projectManager: () => [] satisfies InspectionRole[],
            reviewer: () => [] satisfies InspectionRole[],
            subcontractor: () => [] satisfies InspectionRole[],
            vendor: () => [] satisfies InspectionRole[],
            _: () => [] satisfies InspectionRole[],
          })
        )
      ),
    [assignments]
  )

  return inspectorRoles
}
